/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

var faqAccordion = {
  init: function(){
    var flg = 0;
    var $faqHeading = $('.faqAccordion > dt > button');
    $('.faqAccordion > dd').attr('aria-hidden',true);
    $faqHeading.attr('aria-expanded',false);
    $faqHeading.on('click activate',function(){
      if( flg ) return false;
      flg = 1;
      var state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded',state);
      $(this).parent().next().slideToggle(function(){
        flg = 0;
      });
        $(this).parent().next().attr('aria-hidden',!state);
      return false;
    });
    $faqHeading.on('keydown',function(event){
      var keyCode = event.keyCode || e.which;
      if (keyCode === 13){
        $(this).trigger('activate');
      }
    });
  }
}

faqAccordion.init();


$(document).ready(function(){
  
  $('a.job_question.question_open').click(function(){
    $('.job_answer.answer_open').slideToggle();
    $(this).find('i').toggleClass('t');
  })

})


function refreshCartDrawer() {
  fetch(window.location.pathname + '?sections=cart-drawer')
    .then((res) => res.json())
    .then((data) => {
      const newDrawerHtml = data['cart-drawer'];
      const drawerContainer = document.querySelector('[data-section-id="cart-drawer"]');

      if (drawerContainer) {
        drawerContainer.innerHTML = newDrawerHtml;

        $.getJSON('/cart.js', function (cartState) {
          $(document).trigger('cart_update_start', [cartState]);

          if (
            window.cartDrawerSection &&
            typeof window.cartDrawerSection.update === 'function'
          ) {
            window.cartDrawerSection.update(cartState);
          }

         // $(document).trigger('cart_update_done', [cartState]);
        });

      }
    });
}


  $(document).on('click', '.add-upsell-btn', function () {
    var $btn = $(this);
    var variantId = $btn.data('variant-id');
    var $feedback = $btn.siblings('.upsell-feedback');
    var $upsell = $(this).closest('[data-upsell]');

    $btn.prop('disabled', true).text('Adding...');

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: variantId
      },
      dataType: 'json',
      success: function () {
        $feedback.text('Added to cart!').fadeIn().delay(2000).fadeOut();
        $btn.text('Added');

        $.getJSON('/cart.js', function (cartState) {
          $(document).trigger('cart_update_start', [cartState]);

          if (
            window.cartDrawerSection &&
            typeof window.cartDrawerSection.update === 'function'
          ) {
            window.cartDrawerSection.update(cartState);
          }

          $(document).trigger('cart_update_done', [cartState]);
        });

        $upsell.slideUp();


      },
      error: function () {
        $feedback.text('Error adding item.').fadeIn().delay(2000).fadeOut();
        $btn.prop('disabled', false).text('Add to Cart');
      }
    });
  });


